export default __webpack_public_path__ + "static/media/audioStudy.b8d4ec78.svg";